import React from "react";
import { Box, Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import useCommonStyles from "./style";

const MEDICINE_COLS = ["Medicine", "Dose", "Timing / Anupana", "Duration"];

const HerbalMedicineProtocols = ({ payload }) => {
  const classes = useCommonStyles();
  const p = payload || {};
  const medicineRows = (Array.isArray(p.medicineRows) ? p.medicineRows : []).filter(
    (r) => Array.isArray(r) && r.some(Boolean)
  );
  const herbal = p.herbalRemedy || {};
  const herbalSteps = (Array.isArray(herbal.steps) ? herbal.steps : []).filter(Boolean);
  const shloka = herbal.shloka || {};

  const hasContent =
    p.medicineIntro || medicineRows.length || herbal.label || herbalSteps.length;

  if (!hasContent) {
    return (
      <Box className={classes.hiPlaceholder}>
        <InfoOutlinedIcon className={classes.hiPlaceholderIcon} />
        <Typography className={classes.hiPlaceholderNote}>
          No herbal & medicine protocol available for this patient yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {p.medicineIntro && (
        <Typography className={classes.cbLead}>{p.medicineIntro}</Typography>
      )}

      {medicineRows.length > 0 && (
        <Box className={classes.cbBlock} style={{ overflowX: "auto" }}>
          <table className={classes.symptomTable} style={{ marginBottom: 0 }}>
            <thead>
              <tr>
                {MEDICINE_COLS.map((c) => (
                  <th key={c} className={classes.tableHeader}>
                    {c}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {medicineRows.map((row, i) => (
                <tr key={i}>
                  {MEDICINE_COLS.map((_, j) => (
                    <td key={j} className={classes.tableCell}>
                      {row[j] || "-"}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      )}

      {(herbal.label || herbalSteps.length > 0) && (
        <Box className={classes.cbRemedyCard} style={{ marginTop: 16 }}>
          {herbal.label && (
            <Typography className={classes.pcPrimary}>{herbal.label}</Typography>
          )}

          {herbalSteps.length > 0 && (
            <Box className={classes.cbBlock}>
              <Typography className={classes.cbBlockTitle}>Preparation</Typography>
              <ul className={classes.cbList}>
                {herbalSteps.map((s, i) => (
                  <li key={i}>{s}</li>
                ))}
              </ul>
            </Box>
          )}

          {shloka.sanskrit && (
            <Box className={classes.cbBlock}>
              <Typography
                className={classes.cbBlockText}
                style={{ fontStyle: "italic" }}
              >
                {shloka.sanskrit}
              </Typography>
              {shloka.meaning && (
                <Typography className={classes.hlRowSub}>{shloka.meaning}</Typography>
              )}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default HerbalMedicineProtocols;
